import { html, LitElement, nothing } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import componentStyle from '../common/styles/Component.css'

import style from './NavGroup.css'
import '../icon/Icon.js'

/**
 * Navigation group includes all the actions or items in a single
 * group and is used for grouping items into related categories.
 *
 * @category navigation
 * @status ready
 * @slot - The default slot used for the nav items.
 *
 * @fires {NordEvent} toggle - Dispatched whenever a nav item's state changes between open and closed.
 * @fires {NordEvent} activate - Dispatched whenever a nav item has been marked as active
 */
@customElement('nord-nav-group')
export default class NavGroup extends LitElement {
  static styles = [componentStyle, style]

  /**
   * Heading and accessible label for the nav group
   */
  @property({ reflect: true }) heading?: string

  render() {
    return html`
      ${this.heading ? html`<p id="heading" aria-hidden="true" class="n-heading">${this.heading}</p>` : nothing}
      <div role="list" aria-labelledby=${this.heading ? 'heading' : nothing}>
        <slot></slot>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-nav-group': NavGroup
  }
}
